import { useLegacyUserProfileService } from '@office-start/harmony-data-service';
import { IDLE_VERYLOW_PRIORITY } from '@office-start/scheduler-service';
import React, { lazy } from 'react';
import { withLazyFeatureGateErrorBoundary } from '../LazyFeature/withLazyFeatureGateErrorBoundary';
var TeachingUiContainerComponentLazy = withLazyFeatureGateErrorBoundary(lazy(function () {
    return import(
    /*webpackChunkName: "teaching-ui-container-component" */ '@office-start/teaching-ui-container-component');
}), 'TeachingUiContainerComponent', {
    disabledFeatureGateSelector: function (featureGates) { var _a; return !((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.teachingUiGates) === null || _a === void 0 ? void 0 : _a.teachingUiEnabled); },
    schedulePriority: IDLE_VERYLOW_PRIORITY,
});
export var TeachingUiContainer = function (_a) {
    var scrollContentRef = _a.scrollContentRef;
    var legacyUserProfileService = useLegacyUserProfileService();
    return (React.createElement(TeachingUiContainerComponentLazy, { scrollContentRef: scrollContentRef, userProfileService: legacyUserProfileService }));
};
//# sourceMappingURL=TeachingUiContainer.js.map